/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spell_Numbers_DescInputs */

const en_spell_numbers_desc = /** @type {(inputs: Spell_Numbers_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert numbers to words`)
};

const fr_spell_numbers_desc = /** @type {(inputs: Spell_Numbers_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir les chiffres en mots`)
};

const de_spell_numbers_desc = /** @type {(inputs: Spell_Numbers_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlen in Wörter umwandeln`)
};

const it_spell_numbers_desc = /** @type {(inputs: Spell_Numbers_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertire i numeri in parole`)
};

const ru_spell_numbers_desc = /** @type {(inputs: Spell_Numbers_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преобразуйте числа в слова.`)
};

const es_spell_numbers_desc = /** @type {(inputs: Spell_Numbers_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir números en palabras`)
};

const zh_cn2_spell_numbers_desc = /** @type {(inputs: Spell_Numbers_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将数字转换为文字`)
};

const ja_spell_numbers_desc = /** @type {(inputs: Spell_Numbers_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字を単語に変換する`)
};

const hi_spell_numbers_desc = /** @type {(inputs: Spell_Numbers_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संख्याओं को शब्दों में बदलें`)
};

const pt_pt2_spell_numbers_desc = /** @type {(inputs: Spell_Numbers_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter números em palavras`)
};

/**
* | output |
* | --- |
* | "Convert numbers to words" |
*
* @param {Spell_Numbers_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spell_numbers_desc = /** @type {((inputs?: Spell_Numbers_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spell_Numbers_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spell_numbers_desc(inputs)
	if (locale === "de") return de_spell_numbers_desc(inputs)
	if (locale === "it") return it_spell_numbers_desc(inputs)
	if (locale === "ru") return ru_spell_numbers_desc(inputs)
	if (locale === "es") return es_spell_numbers_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_spell_numbers_desc(inputs)
	if (locale === "ja") return ja_spell_numbers_desc(inputs)
	if (locale === "hi") return hi_spell_numbers_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_spell_numbers_desc(inputs)
	return en_spell_numbers_desc(inputs)
});